import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { Observable } from 'rxjs';
import { XeroAccount } from '../../models/xero/xero-account';
import { TaxRate } from '../../models/xero/tax-rate';
import { getQueryStringFromObject } from '../helpers/getQueryStringFromObject';

export interface XeroAccountConfig {
  [name: string]: string;
}

@Injectable()
export class XeroService {
  constructor(private http: ApiClient) {}

  getXeroConnectionUrl() {
    return this.http.get('settings/xero/connect-url');
  }

  getXeroStatus() {
    return this.http.get('settings/xero/status');
  }

  registerXeroConfiguration(code) {
    return this.http.post('settings/xero/register', { code });
  }

  disconnectXero() {
    return this.http.get('settings/xero/disconnect');
  }

  getXeroAccounts(): Observable<XeroAccount[]> {
    return this.http.get('settings/xero/xero-accounts');
  }

  getConfiguredAccounts(): Observable<XeroAccountConfig> {
    return this.http.get('settings/xero/account-config');
  }

  saveConfiguredAccounts(accountConfig: XeroAccountConfig) {
    return this.http.post('settings/xero/account-config', accountConfig);
  }

  createXeroAccount(xeroAccount: XeroAccount) {
    return this.http.post('settings/xero/account', xeroAccount);
  }

  getXeroTaxRates() {
    return this.http.get('settings/xero/tax-rate');
  }

  createXeroTaxRates(taxRate: TaxRate) {
    return this.http.post('settings/xero/tax-rate', taxRate);
  }

  saveXeroTaxRatesConfig(config: any) {
    return this.http.put('settings/xero/tax-rate-config', config);
  }

  getReportData(params, criteria) {
    const qs = getQueryStringFromObject(params);
    return this.http.post<any[]>(`xero/report?${qs}`, criteria);
  }

  importItems() {
    return this.http.get(`settings/xero/import-items`);
  }

  importContacts() {
    return this.http.get('settings/xero/import-contacts');
  }
}
